// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__P5Ei2","checkbox":"Checkbox_checkbox__TzX+a","hitArea":"Checkbox_hitArea__kGonz","label":"Checkbox_label__lxji1"};